export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mb-6">
      <div>
        <h1 className="font-display text-2xl sm:text-[28px] font-extrabold tracking-tight text-pawkt-text leading-tight">{title}</h1>
        {subtitle && <p className="text-sm text-pawkt-text-secondary mt-1">{subtitle}</p>}
      </div>
      {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
    </div>
  );
}
